/** Auto-archive settings and an archived agent session's footer. */
export default {
  title: 'Auto-archive',
  description: 'A session you unarchive is never archived automatically again.',
  pullRequestsMerge: 'When its pull requests merge',
  pullRequestsMergeDescription:
    'Once every linked pull request is closed and at least one merged',
  sessionCloses: 'When its machine session closes',
  sessionClosesDescription:
    'Once the session running it is closed on purpose, like closing its Herdr tab',
  archived: 'This session is archived',
  archivedWhenPullRequestsMerged:
    'Archived automatically when its pull requests merged',
  archivedWhenSessionClosed:
    'Archived automatically when its machine session closed',
  unarchiveToContinue: 'Unarchive it to rename the session or send messages.',
  unarchiving: 'Unarchiving…',
};
